import { forwardRef, useEffect, useState } from "react";
import { consumablesService } from "../../../services/consumables.service";
import CreatableSelect from "react-select/creatable";
import { IConsumableItemOption } from "Dashboard/scenes/Consumables/domain/IConsumableItemOption";

const ConsumableItemSelectCreate = forwardRef<any, any>((props, ref) => {
  const [isLoading, setIsLoading] = useState(true);
  const [options, setOptions] = useState<IConsumableItemOption[]>([]);
  const [value, setValue] = useState<IConsumableItemOption | undefined>(undefined);
  const [inputValue, setInputValue] = useState<string | undefined>(undefined);

  useEffect(() => {
    async function getData() {
      const items = await consumablesService.getAllKnownInputItems();
      const op = items.map((item) => {
        return {
          label: item.name,
          value: item.itemId,
          itemCode: item.latestItemCode ? item.latestItemCode : undefined,
          knownItemCodes: item.knownItemCodes ? item.knownItemCodes : [],
          category: item.category ? item.category.name : undefined,
          quantityUnit: item.latestQuantityUnit
            ? item.latestQuantityUnit.unitId
            : undefined,
        };
      });
      setOptions(op);
      setIsLoading(false);
    }

    try {
      getData();
    } catch (err) {
      console.log(err);
    }
  }, []);

  const handleChange = (newValue: any, actionMeta: any) => {
    setValue(newValue);
    props.onChange(newValue ? newValue.value : null);
    if (props.category !== undefined) {
      props.setValue(props.category, newValue ? newValue.category : "", {
        shouldValidate: false,
        shouldDirty: true,
      });
    }
    if (props.itemCode !== undefined) {
      props.setValue(props.itemCode, newValue ? newValue.itemCode : "", {
        shouldValidate: false,
        shouldDirty: true,
      });
    }
    if (props.setKnownItemCodes !== undefined) {
      props.setKnownItemCodes(newValue ? newValue.knownItemCodes : []);
    }
    if (props.quantityUnit !== undefined) {
      props.setValue(props.quantityUnit, newValue ? newValue.quantityUnit : undefined, {
        shouldValidate: false,
        shouldDirty: true,
      });
    }
  };

  useEffect(() => {
    if (!isLoading) {
      const values = options.filter((o) => o.value === props.value);
      if (values[0]) {
        setValue(values[0]);
      } else {
        setValue(undefined);
      }
    }
  }, [options, props.value, isLoading]);

  const createOption = async (name: string): Promise<IConsumableItemOption> => {
    try {
      const item = await consumablesService.createInputItem(name);
      return {
        label: item.name,
        value: item.itemId,
        itemCode: item.latestItemCode ? item.latestItemCode : undefined,
        knownItemCodes: item.knownItemCodes ? item.knownItemCodes : [],
        category: undefined,
        quantityUnit: undefined,
      };
    } catch (err) {
      throw err;
    }
  };

  const handleCreate = async (inputValue: any) => {
    try {
      setIsLoading(true);
      const newOption = await createOption(inputValue);
      setOptions([...options, newOption]);
      handleChange(newOption, null);
      setIsLoading(false);
    } catch (err) {
      console.log(err);
    }
  };

  const formatCreate = (inputValue: string) => {
    return <p> Dodaj: {inputValue}</p>;
  };

  return (
    <CreatableSelect
      styles={props.customStyles}
      menuPosition="fixed"
      ref={ref}
      isClearable
      placeholder={""}
      formatCreateLabel={formatCreate}
      isDisabled={isLoading}
      isLoading={isLoading}
      onChange={handleChange}
      onCreateOption={handleCreate}
      inputValue={props.preserveInput && inputValue}
      onInputChange={props.preserveInput &&
        ((newVal) => setInputValue(newVal))}
      onMenuOpen={props.preserveInput &&
        (() => setInputValue(value?.label))}
      onMenuClose={props.preserveInput &&
        (() => setInputValue(undefined))}
      options={options}
      value={value}
      {...{ error: props.error }}
    />
  );
});

export default ConsumableItemSelectCreate;
